/* eslint-disable react/no-unknown-property */
import React from 'react';
import PropTypes from 'prop-types';

export const IconLeft = ({ className }) => (
  <svg className={className} fill="none" height="21" viewBox="0 0 20 21" width="20" xmlns="http://www.w3.org/2000/svg">
    <mask height="14" id="mask0_18535_37382" mask-type="alpha" maskUnits="userSpaceOnUse" width="13" x="4" y="4">
      <path d="M5.00033 4.66699C5.46056 4.66699 5.83366 5.04009 5.83366 5.50033V10.5003C5.83366 10.9424 6.00925 11.3663 6.32181 11.6788C6.63437 11.9914 7.0583 12.167 7.50033 12.167H13.8218L11.9111 10.2562C11.5856 9.93081 11.5856 9.40317 11.9111 9.07774C12.2365 8.7523 12.7641 8.7523 13.0896 9.07774L16.4229 12.4111C16.7484 12.7365 16.7484 13.2641 16.4229 13.5896L13.0896 16.9229C12.7641 17.2484 12.2365 17.2484 11.9111 16.9229C11.5856 16.5975 11.5856 16.0698 11.9111 15.7444L13.8218 13.8337H7.50033C6.61627 13.8337 5.76842 13.4825 5.1433 12.8573C4.51818 12.2322 4.16699 11.3844 4.16699 10.5003V5.50033C4.16699 5.04009 4.54009 4.66699 5.00033 4.66699Z" fill="#5E811E"/>
    </mask>
    <g mask="url(#mask0_18535_37382)">
      <path d="M19.5 1V20H0.5V1H19.5Z" fill="#EAECF0" stroke="#EAECF0"/>
    </g>
  </svg>
);

IconLeft.propTypes = {
  className: PropTypes.string
};
